/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
// 使用简单的文本图标，避免依赖@mui/icons-material
import { useTranslation } from 'react-i18next';
import { useTranslation as useVenusTranslation } from 'translation';

interface Language {
  code: string;
  name: string;
  flag: string;
}

const getLanguages = (t: any): Language[] => [
  { code: 'zh', name: t('language.chinese'), flag: '🇨🇳' },
  { code: 'en', name: t('language.english'), flag: '🇺🇸' },
];

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const { t } = useVenusTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const languages = getLanguages(t);
  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode); // 保存语言设置到localStorage
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          ml: 1,
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '@media (max-width: 960px)': {
            ml: 0,
            mr: 1,
            minWidth: 'auto',
            padding: '6px',
          },
        }}
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        title={t('language.switchLanguage')}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span style={{ fontSize: '16px' }}>{currentLanguage.flag}</span>
          <span role="img" aria-label="language" style={{ fontSize: '12px' }}>🌐</span>
        </Box>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={language.code === i18n.language}
            sx={{ minWidth: 120 }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <span style={{ fontSize: '18px' }}>{language.flag}</span>
            </ListItemIcon>
            <ListItemText primary={language.name} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;